import Vue from 'vue'
import Vuex from 'vuex'
import DAOWishlist from '@/../public/js/DAO/Wishlist.js';
import CorrectItem from "@/assets/DAO/Item/CorrectItem";
import Logger from "@/assets/Helper/Logger";
import Engraving from "@/vuex/Engraving";
import DAOItemDescription from "@/assets/DAO/Item/Description";
import DAOItemAdditionalItems from "@/assets/DAO/Item/AdditionalItems";
import DAOItemPrice from "@/assets/DAO/Item/Price";
import Config from "@/vuex/Config";

Vue.use(Vuex)

let SetData = new Vuex.Store({
    state: {
        setId: "",
        setParameter: null,
        showSetImage: false,
        showSetIn3d: {},
        description3d: [],
        totalPrice: 0.00,
        totalPriceOriginal: 0.00,
        totalDiscount: 0.00,
        totalPriceWeddingbands: 0.00,
        totalPriceJewellery: 0.00,
        totalPriceEngraving: 0.00,
        isModelDiscount: false,
        currentItem: 'set',
        items: [],
        itemnumbersStart: [],
        itemnumbers: [],
        itemStr: [],
        summary: [],
        additionalItems: [],
        overSize: {"weddingring": 67, "jewelleryring": 59},
        wishlistItemId: null,
        diamondExchange: {
            search: {
                carat: null,
                color: null,
                form: null,
                finish: null,
                purity: null,
                polish: null,
                symmetry: null,
                fluorescence: null,
                certificateNo: null,
                certificate: null,
                showWishlist: null,
                stoneIds: null,
            }
        }
    },
    actions: {
        restoreWishlistData(context, wishlistData) {
            context.commit("restoreWishlistData", wishlistData);
        },
        setSetId(context, setId) {
            context.commit('setSetId', setId);
        },
        setShowSetImage(context, show) {
            context.commit('setShowSetImage', show);
        },
        setShowSetIn3d(context, data) {
            context.commit('setShowSetIn3d', data);
        },
        setItemDescription3d(context, itemDecription3d) {
            context.commit('setItemDescription3d', itemDecription3d);
        },
        setSetIdParameters(context, setParameter) {
            if (
                typeof setParameter === 'object' &&
                setParameter !== null &&
                typeof setParameter.fineness !== 'undefined' &&
                typeof setParameter.stoneQuality !== 'undefined' &&
                typeof setParameter.stonePriceType !== 'undefined'
            ) {
                setParameter = {
                    "fineness": setParameter.fineness,
                    "height": setParameter.height,
                    "stoneQuality": setParameter.stoneQuality,
                    "stonePriceType": setParameter.stonePriceType
                }
            } else {
                setParameter = null;
            }
            context.commit('setSetIdParameters', setParameter);
        },
        clearItems(context, keepSetId) {
            context.commit('clearItems', keepSetId);
        },
        addItem(context, itemnumber) {
            if (this.state.items.length < 4) {
                context.commit('addItem', itemnumber);
            }
        },
        setItemnumbers(context, itemnumbers) {
            context.commit('setItemnumbers', itemnumbers);
        },
        setItemnumbersStart(context, itemnumbers) {
            context.commit('setItemnumbersStart', itemnumbers);
        },
        setNameOfItem(context, name) {
            if (typeof name === 'string') {
                context.commit('setNameOfItem', name);
            }
        },
        setItem(context, item) {
            context.commit('setItem', item);
        },
        dropItem(context, itemKey) {
            context.commit('dropItem', itemKey);
        },
        setItemPrice(context, itemPriceDetails) {
            context.commit('setItemPrice', itemPriceDetails);
        },
        setItemDescription(context, itemDecription) {
            context.commit('setItemDescription', itemDecription);
        },
        setSummary(context, summary) {
            context.commit('setSummary', summary);
        },
        setCurrentItem(context, currentItem) {
            if (currentItem === 'overview' || currentItem === 'all' || currentItem === 'set' || currentItem === '0' || currentItem < 10) {
                context.commit('setCurrentItem', currentItem);
            }
        },
        setAdditionalItems(context, additionalItems) {
            context.commit('setAdditionalItems', additionalItems);
        },
        setItemSize(context, size) {
            context.commit('setItemSize', size);
        },
        setItemEngraving(context, engravingData) {
            if (typeof engravingData.inside === 'object' && typeof engravingData.outside === 'object') {
                context.commit('setItemEngraving', engravingData);
            }
        },
        setWishListItemId(context, wishlistItemId) {
            context.commit('setWishListItemId', wishlistItemId);
        },
        setDiamondExchangeSearch(context, search) {
            context.commit('setDiamondExchangeSearch', search);
        }
    },
    mutations: {
        restoreWishlistData(state, wishlistData) {
            state.wishlistItemId = wishlistData.wishlistItemId;
            state.setParameter = wishlistData.setParameter;
            state.showSetIn3d = wishlistData.showSetIn3d;
            state.setId = wishlistData.setId;
            state.itemnumbersStart = wishlistData.itemnumbersStart;
            if (state.setId != '' && wishlistData.items.length > 1) {
                state.showSetImage = true;
            }

            state.items = [];
            state.itemnumbers = [];

            for (let i in wishlistData.items) {
                if (Object.prototype.hasOwnProperty.call(wishlistData.items, i)) {
                    let newItem = {
                        name: wishlistData.items[i].name,
                        itemnumber: wishlistData.items[i].itemnumber,
                        price: {
                            ring: 0,
                            stone: 0,
                            discount: 0,
                            fixPrice: {},
                            engraving: 0,
                            total: 0
                        },
                        size: wishlistData.items[i].size,
                        engraving: wishlistData.items[i].engraving,
                        description: {}
                    };

                    state.items.push(newItem)
                    state.itemnumbers.push(wishlistData.items[i].itemnumber + ":" + wishlistData.items[i].size);
                    state.itemStr = state.itemnumbers.join("_");

                    DAOItemPrice.getPrice(wishlistData.items[i].itemnumber + ":" + wishlistData.items[i].size);
                }
            }

            DAOItemDescription.getDescription(state.itemnumbers);
            DAOItemAdditionalItems.getItems(state.itemnumbers);

            if (state.items.length === 1) {
                state.currentItem = 0
            }
        },
        setWishListItemId(state, wishlistItemId) {
            state.wishlistItemId = wishlistItemId;
        },
        clearItems(state, keepSetId) {
            if (typeof keepSetId === 'undefined' || keepSetId !== true) {
                state.setId = "";
                state.showSetImage = false;
                state.showSetIn3d = {};
                state.itemnumbersStart = [];
            }

            state.totalPrice = 0.00;
            state.currentItem = 'set';
            state.items = [];
            state.itemnumbers = [];
            state.itemStr = "";
            state.summary = [];
            state.additionalItems = [];
            state.description3d = [];
        },
        setSetId(state, setId) {
            if (state.setId !== setId || state.items.length < 1) {
                state.setId = setId;
            }
        },
        setShowSetImage(state, show) {
            if (state.setId == '') {
                show = false;
            }
            state.showSetImage = show === true;
        },
        setShowSetIn3d(state, data) {
          if (typeof data === 'object') {
            state.showSetIn3d = data;
          }
        },
        setItemDescription3d(state, itemDecription3d) {
            if (typeof itemDecription3d === 'object') {
                state.description3d = itemDecription3d;
            }
        },
        setSetIdParameters(state, setParameter) {
            state.setParameter = setParameter;
        },
        setNameOfItem(state, name) {
            let key = (state.currentItem === 'overview' || state.currentItem === 'all' || state.currentItem === 'set') ? 0 : state.currentItem;
            state.items[key].name = name;

            if (typeof state.wishlistItemId === 'number') {
                DAOWishlist.update('configure', state.wishlistItemId, SetData.getters.getWishlistItemData)
                    .catch((error) => {
                        Logger.error(error);
                    });
            }

        },
        addItem(state, itemnumber) {
            let itemSize = false;

            if (itemnumber.indexOf(":") !== -1) {
                itemSize = itemnumber.substring(itemnumber.indexOf(':') + 1, itemnumber.length);
                itemnumber = itemnumber.substring(0, itemnumber.indexOf(':'));
            } else {
                itemSize = (state.items.length === 1) ? 62 : 54;
            }

            let engravingData = {
                inside: {
                    text: '',
                    font: 0
                },
                outside: {
                    text: '',
                    font: 0
                }
            }

            let newItem = {
                name: "",
                itemnumber: itemnumber,
                price: {
                    ring: 0,
                    stone: 0,
                    discount: 0,
                    fixPrice: {},
                    engraving: 0,
                    total: 0
                },
                size: itemSize,
                engraving: engravingData,
                description: {}
            };

            state.items.push(newItem)
            state.itemnumbers.push(itemnumber + ":" + itemSize);
            state.itemStr = state.itemnumbers.join("_");
        },
        setItemnumbers(state, itemnumbers) {
            if (typeof itemnumbers == 'object' && itemnumbers.length > 0) {
                state.itemnumbers = itemnumbers;
            }
        },
        setItemnumbersStart(state, itemnumbers) {
            if (typeof itemnumbers == 'object') {
                state.itemnumbersStart = itemnumbers;
            }
        },
        setItem(state, item) {
            item.key = (item.key === false) ? state.currentItem : item.key;
            item.key = (item.key === 'overview' || item.key === 'all' || item.key === 'set') ? 0 : item.key;

            state.items[item.key].itemnumber = item.id;
            state.itemnumbers[item.key] = item.id + ":" + state.items[item.key].size;
            state.itemStr = state.itemnumbers.join("_");
        },
        dropItem(state, itemKey) {
            state.items.splice(itemKey, 1);
            state.itemnumbers.splice(itemKey, 1);
            state.itemStr = state.itemnumbers.join("_");
            this.commit('calculateTotalPrice');

            if (state.items.length === 1) {
                state.currentItem = 0
            }
        },
        calculateTotalPrice(state) {
            state.totalPrice = 0;
            state.totalDiscount = 0;
            state.totalPriceOriginal = 0;
            state.isModelDiscount = false;
            state.totalPriceEngraving = 0;
            state.totalPriceWeddingbands = 0; // Without engraving
            state.totalPriceJewellery = 0; // Without engraving

            for (let key in state.items) {
                if (Object.prototype.hasOwnProperty.call(state.items, key)) {
                    state.items[key].price.engraving = 0;
                    let jewelleryType = (parseInt(state.items[key].description.jewelleryType) > 0) ? 'jewellery' : 'standard';

                    if (state.items[key].engraving.inside.font > 0) {
                        state.items[key].price.engraving += Engraving.getters.getCostsById(jewelleryType, state.items[key].engraving.inside.font);
                    }

                    if (state.items[key].engraving.outside.font > 0) {
                        state.items[key].price.engraving += Engraving.getters.getCostsById(jewelleryType, state.items[key].engraving.outside.font);
                    }

                    state.totalPrice += state.items[key].price.total + state.items[key].price.engraving;
                    state.totalDiscount += state.items[key].price.discount;

                    if (state.items[key].price.fixPrice && state.items[key].price.fixPrice['originalTotal']) {
                        state.totalPriceOriginal += state.items[key].price.fixPrice['originalTotal'];
                    } else if (state.totalDiscount > 0) {
                        state.totalPriceOriginal += state.items[key].price.totalOriginal + state.items[key].price.engraving;
                    }

                    state.totalPriceEngraving += state.items[key].price.engraving;

                    if (jewelleryType === 'jewellery') {
                      state.totalPriceJewellery += state.items[key].price.total;
                    } else {
                      state.totalPriceWeddingbands += state.items[key].price.total;
                    }

                    if (state.items[key].price.isModelDiscount) {
                      state.isModelDiscount = true;
                    }
                }
            }
        },
        setItemPrice(state, itemPriceDetails) {
            for (let key in state.items) {
                if (Object.prototype.hasOwnProperty.call(state.items, key)) {
                    if (state.items[key].itemnumber + ":" + state.items[key].size === itemPriceDetails.itemnumber) {
                        state.items[key].price.ring = itemPriceDetails.ring;
                        state.items[key].price.stone = itemPriceDetails.stone;
                        state.items[key].price.total = itemPriceDetails.total;
                        state.items[key].price.totalPrice = itemPriceDetails.totalPrice;
                        state.items[key].price.discount = itemPriceDetails.discount ? itemPriceDetails.discount : 0;
                        state.items[key].price.fixPrice = itemPriceDetails.fixPrice ? itemPriceDetails.fixPrice : {};
                        state.items[key].price.totalOriginal = itemPriceDetails.totalOriginal ? itemPriceDetails.totalOriginal : itemPriceDetails.total;
                        state.items[key].price.isModelDiscount = itemPriceDetails.isModelDiscount ?? false;
                    }
                }
            }
            this.commit('calculateTotalPrice');
        },
        setItemDescription(state, itemDecription) {
            for (let key in state.items) {
                if (Object.prototype.hasOwnProperty.call(state.items, key)) {
                    if (state.items[key].itemnumber + ":" + state.items[key].size === itemDecription.itemnumber) {
                        state.items[key].description = itemDecription;
                        if (state.setId == '' &&
                            typeof state.items[key].description.setId == 'string' &&
                            state.items[key].description.setId != ""
                        ) {
                            state.setId = state.items[key].description.setId;

                            if (state.items.length > 1) {
                                state.showSetImage = true;
                            } else {
                                state.showSetImage = false;
                            }
                        }

                        if (Config.getters.getLastCurrentVarType == '') {
                            if (itemDecription.jewelleryType !== 0 || itemDecription.possibleVariations.profiles == false) {
                                if (itemDecription.isBasicModel === true) {
                                    Config.dispatch("setCurrentVarType", "metals");
                                } else {
                                    Config.dispatch(
                                      "setCurrentVarType",
                                      itemDecription.brandId === 16 &&
                                        itemDecription.jewelleryType === 11
                                        ? "jewellery/necklace"
                                        : "colors"
                                    );
                                }
                            } else {
                                setTimeout(() => {
                                    Config.dispatch(
                                      "setCurrentVarType",
                                      "profiles"
                                    );
                                }, 150);
                            }
                        }
                    }
                }
            }

            this.commit('calculateTotalPrice');
        },
        setSummary(state, summary) {
            state.summary = summary;
        },
        setCurrentItem(state, currentItem) {
            if ((currentItem === 'overview' || currentItem === 'set') && state.items.length === 1) {
                currentItem = 0
            }
            state.currentItem = currentItem;
        },
        setAdditionalItems(state, additionalItems) {
            state.additionalItems = additionalItems;
        },
        setItemSize(state, size) {
            if (typeof state.items[state.currentItem] === 'object') {
                state.items[state.currentItem].size = size;

                state.itemnumbers[state.currentItem] = state.itemnumbers[state.currentItem].substring(0, state.itemnumbers[state.currentItem].indexOf(':') + 1) + size;
                state.itemStr = state.itemnumbers.join("_");

                CorrectItem.byItemnumber(state.items[state.currentItem].itemnumber + ":" + state.items[state.currentItem].size, state.currentItem);
            }
        },
        setItemEngraving(state, engravingData) {
            if (typeof state.items[state.currentItem] === 'object') {
                state.items[state.currentItem].engraving.inside.text = engravingData.inside.text;
                state.items[state.currentItem].engraving.inside.font = engravingData.inside.font;

                state.items[state.currentItem].engraving.outside.text = engravingData.outside.text;
                state.items[state.currentItem].engraving.outside.font = engravingData.outside.font;

                this.commit('calculateTotalPrice');
            }

            if (typeof state.wishlistItemId === 'number') {
                DAOWishlist.update('configure', state.wishlistItemId, SetData.getters.getWishlistItemData)
                    .catch((error) => {
                        Logger.error(error);
                    });
            }
        },
        setDiamondExchangeSearch(state, search) {
            if (typeof search === 'object' && typeof search['carat'] === 'string') {
                state.diamondExchange.search = search;
            }
        }
    },
    getters: {
        getSet: state => {
            return state;
        },
        getSetId: state => {
            return state.setId;
        },
        getSetIdParameter: state => {
            return state.setParameter;
        },
        getShowSetImage: state => {
            return state.showSetImage;
        },
        getShowSetIn3d: state => {
            return state.showSetIn3d;
        },
        getDescription3d: state => {
            return state.description3d;
        },
        getCurrentItem: state => {
            if (state.items.length === 1) {
                return state.items[0];
            } else if (state.currentItem === 'overview' || state.currentItem === 'all' || state.currentItem === 'set') {
                return 'all';
            } else {
                return state.items[state.currentItem];
            }
        },
        getCurrentItemId: state => {
            return state.currentItem;
        },
        getItemnumbers: state => {
            return state.itemnumbers;
        },
        getItemnumbersStart: state => {
            return state.itemnumbersStart;
        },
        getItemStr: state => {
            return state.itemStr;
        },
        getTotalPrice: state => {
            return state.totalPrice;
        },
        getAdditionalItems: state => {
            return state.additionalItems;
        },
        getWishlistItemId: state => {
            return state.wishlistItemId;
        },
        getWishlistItemData: state => {
            let items = [];

            for (let i in state.items) {
                if (Object.prototype.hasOwnProperty.call(state.items, i)) {
                    let itemData = JSON.parse(JSON.stringify(state.items[i]));

                    delete itemData.price;
                    delete itemData.description;

                    items.push(itemData);
                }
            }

            return {
                date: Date.now(),
                setId: state.setId,
                itemnumbersStart: state.itemnumbersStart,
                showSetIn3d: state.showSetIn3d,
                setParameter: state.setParameter,
                totalPrice: state.totalPrice,
                items: items
            };
        },
        getShoppingCartData: state => {
            let shoppingCart = {
                setId: state.setId,
                items: []
            }

            for (let i in state.items) {
                if (Object.prototype.hasOwnProperty.call(state.items, i)) {
                    let item = {
                        name: state.items[i].name,
                        itemnumber: state.items[i].itemnumber,
                        size: state.items[i].size,
                        engraving: {
                            inside: {
                                text: state.items[i].engraving.inside.text,
                                font: (state.items[i].engraving.inside.font > 0) ? state.items[i].engraving.inside.font : ''
                            },
                            outside: {
                                text: state.items[i].engraving.outside.text,
                                font: (state.items[i].engraving.outside.font > 0) ? state.items[i].engraving.outside.font : ''
                            }
                        }
                    };

                    shoppingCart.items.push(item);
                }
            }

            return shoppingCart;
        },
        getOverSize: state => {
            return state.overSize;
        },
        getRingLayout: state => {
            if (state.items.length === 1) {
                return state.items[0].description.ringType;
            } else if (state.currentItem === 'overview' || state.currentItem === 'all' || state.currentItem === 'set') {
                let ringType = 0;

                for (let itemId in state.items) {
                    if (ringType === 0) {
                        ringType = state.items[itemId].description.ringType;
                    } else if (ringType != state.items[itemId].description.ringType) {
                        ringType = 1;
                    }
                }

                return ringType;
            } else {
                return state.items[state.currentItem].description.ringType;
            }
        },
        getDiamondExchangeSearch: state => {
            return state.diamondExchange.search;
        }
    }
})

export default SetData;
